const StatusPermohonanRegistrasi =  {
    VERIFIKASI_TEKNIS : 'Verifikasi Teknis',
    PEMBUATAN_DRAFT_SK : 'Pembuatan Draft SK',
    DRAFT_SK_TANDA_TANGAN_DIREKTUR : 'Draft SK Tanda Tangan Direktur',
    KIRIM_INSW : 'Kirim INSW',
    SELESAI : 'Selesai',
    DITOLAK : 'Ditolak',
}

export default StatusPermohonanRegistrasi;